<div class="form-field">
  <fieldset [class.disabled]="disabled">
    <div class="custom-radio-group" [ngStyle]="{'flex-direction' : flexRow ? 'row': '', 'gap' : flexRow ? '20px' : ''}">
      <label *ngFor="let option of options" class="custom-radio" [class.disabled]="disabled">
        <input type="radio" [value]="option.value" [checked]="selectedValue === option.value"
               (change)="selectValue(option.value)" [disabled]="disabled" [name]="label" [required]="required"/>
        <span class="radio-mark"></span>
        {{ option.label }}
      </label>
    </div>
    <legend>{{label}}</legend>
  </fieldset>
</div>
